/**
 * 系统管理 客户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理员管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索：">
        <el-select size="small" v-model="formInline.isLock" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="正常" value="N"></el-option>
          <el-option label="已锁定" value="Y"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.userName" placeholder="输入客户名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.userMobile" placeholder="输入手机号"></el-input>
      </el-form-item> -->
      <el-form-item>
        <!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
        <!-- <el-button size="small" type="primary" @click="handleunit()">部门设置</el-button> -->
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="50">
      </el-table-column>

    <el-table-column align="center" sortable prop="id" label="ID" width="50">
      </el-table-column>

      <el-table-column align="center" sortable prop="username" label="用户名" width="100">
      </el-table-column>
        <el-table-column align="center" sortable prop="nickname" label="昵称" width="100">
      </el-table-column>
         <el-table-column align="center" sortable prop="role.name" label="角色" width="120">
      </el-table-column>
         <el-table-column align="center" sortable prop="last_login_time" label="上次登录" width="150">
      </el-table-column>

      <el-table-column align="center" sortable prop="create_time" label="创建时间" width="150">
        <template slot-scope="scope">
          <div>{{scope.row.create_time}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-color="#13ce66"  :active-value="nshow"  :inactive-value="fshow"  inactive-color="#dcdfe6" @change="editType($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
        <el-table-column align="center" sortable prop="error_num" label="是否锁定" width="100">
          <template slot-scope="scope">
           <span v-if="scope.row.error_num>0" >
            <el-button @click="UnlockUser(scope.row.id)" type="warning" size="mini" round>异常</el-button>
          </span>
          <span v-if="scope.row.error_num===0">
            <el-button type="success" size="mini" round>正常</el-button>
          </span>
        </template>
      </el-table-column>
       <el-table-column align="center" sortable prop="expire_time" label="到期时间" width="150">
      </el-table-column>
       <el-table-column align="center" sortable prop="last_login_ip" label="登录ip" width="120">
      </el-table-column>
      <el-table-column align="center" sortable prop="login_num" label="登录次数" width="100">
      </el-table-column>
      <el-table-column align="center" sortable prop="error_num" label="错误次数" width="100">
      </el-table-column>
      <el-table-column label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>

          <!-- <el-button size="mini" type="success" @click="offlineUser(scope.$index, scope.row)">下线</el-button>
      -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules" status-icon>

        <el-form-item label="用户名" prop="username">
          <el-input size="small" v-model="editForm.username" auto-complete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>

         <el-form-item label="密码" prop="pwd">
          <el-input size="small"  type="password"  v-model="editForm.pwd" auto-complete="off" placeholder="请输入密码"></el-input>
        </el-form-item>
         <el-form-item label="昵称" prop="nickname">
          <el-input size="small" v-model="editForm.nickname" auto-complete="off" placeholder="请输入昵称"></el-input>
        </el-form-item>
          <el-form-item label="有效时间" prop="expire_time">
          <el-date-picker
            v-model="editForm.expire_time"
            align="right"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择到期日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
         <el-form-item label="角色" prop="role_id">
           <el-select v-model="editForm.role_id" placeholder="请选择角色">
                        <el-option
                          v-for="item in roles"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id">
                        </el-option>
                      </el-select>
        </el-form-item>
        <el-form-item label="生效">
           <el-switch v-model="editForm.status"  :active-value="active_value"  :inactive-value="inactive_value"  ></el-switch>
      </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title"  @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    
   
  </div>
</template>

<script>
// 导入请求方法
import {
addAdmin,
roleList,
get_admin_list,
changeAdminStatus,
getAdminById,
adminDelete,
editAdmin,
UnlockUser,
} from '@/api/userFun'
import Pagination from '../../components/Pagination'
export default {
  data() {

    return {
      roles:[],
      type:1, //1代表新增 2表示编辑
      active_value:1,
      inactive_value:0,
      nshow: 1, //switch开启
      fshow: 0, //switch关闭
      loading: false, //是显示加载
      title: '添加客户',
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      unitAccessshow: false, //控制所属单位隐藏与显示
      // 编辑与添加
      editForm: {
        username: '',
        status:1,
        pwd:"",
        nickname:"",
        role_id:"",
        expire_time:'',

      },
      pickerOptions: {
          // disabledDate(time) {
          //   return time.getTime() < Date.now();
          // },
          shortcuts: [{
            text: '3天',
            onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
                picker.$emit('pick', date);
            }
          }, {
            text: '7天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }, {
            text: '90天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit('pick', date);
            }
          }]
        },
      
      // 选择数据
      selectdata: [],
      // rules表单验证
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
         pwd: [
          { validator: this.validatePass, trigger: 'blur' }
        ],
         nickname: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ],
         role_id: [
          { required: true, message: '请选择角色', trigger: 'blur' }
        ],
      
      },
      // 删除客户
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      // 重置密码
      resetpsd: {
        userId: '',
        token: localStorage.getItem('logintoken')
      },
      // 客户下线
      offline: {
        token: localStorage.getItem('logintoken')
      },
      // 请求数据参数
      formInline: {
        page: 1,
        // limit: 10,
        userName: '',
        userMobile: '',
        isLock: ''
      },
      //客户数据
      userData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {

    this.get_admin_list(this.formInline);
    this.getRole();
   
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {


    //解除锁定
    UnlockUser(uid){
       // console.log(uid);
        let arr={};
         arr['id']=uid;
        UnlockUser(arr).then(res=>{
            if(res.code==200){
               this.$message({
                type: 'success',
                message: res.msg
              });
             this.get_admin_list(this.formInline);
            }
        })
    },

    //校验密码复杂程度
     validatePass(rule, value, callback){
      if(this.type===2){ //编辑
       
        if(this.editForm.pwd==''){
           callback();
        }else{
        var reg=/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\.]{8,}$/;
          if(!reg.test(value)){ 
            callback(new Error('要求8位以上,包含数字,大小写字母,特殊符号'));
            }else{
              callback();
            }
        }      
      }else{
        var reg=/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\.]{8,}$/;
     // console.log('校验密码复杂程度')
      if(!reg.test(value)){ 
         callback(new Error('要求8位以上,包含数字,大小写字母,特殊符号'));
        }else{
          callback();
        }
      }
      
    },

    //获取角色选项
      getRole(){
        roleList().then(res=>{
          let ls=[];
           res.data.forEach((item,index)=>{
              ls.push({
              label:item.name,
              id:item.id
            });
          });
          this.roles=ls;
        })
      },
    // 获取数据方法
    get_admin_list(parameter) {
      // console.log(parameter);
      // return;
      get_admin_list(parameter).then(res=>{
        this.userData = res.data.data;
      // 分页赋值
      this.pageparm.currentPage = res.data.current_page
      this.pageparm.pageSize = res.data.per_page
      this.pageparm.total = res.data.total
      })
     
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.get_admin_list(this.formInline)
    },

    clearForm(form){
        this.$refs[form].resetFields();
        this.dialogVisible=false;
        if(this.editForm.hasOwnProperty('id')){
            delete this.editForm.id;
        }

     },
    //搜索事件
    search() {
      this.get_customer_list(this.formInline)
    },
    // 修改type
    editType: function($event, row) {
     let  $data={
        id:row.id,
        status:$event,
      }
      this.loading = true
     // return;
      // 修改状态
      changeAdminStatus($data).then(res => {
        this.loading = false
        if (res.code !== 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.$message({
            type: 'success',
            message: '状态修改成功'
          })
          this.get_admin_list(this.formInline)
        }
      })
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.type=2//编辑模式
      if (row != undefined && row != 'undefined') {
        this.title = '修改客户'
      getAdminById({id:row.id}).then(res=>{
        this.title = '修改'
        this.editForm.username=res.data.username;
        this.editForm.status=res.data.status;
        this.editForm.nickname=res.data.nickname;
        this.editForm.role_id=res.data.role_id;
        this.editForm.id=res.data.id;
         this.editForm.expire_time=res.data.expire_time;
      })
    
      } else {
        this.title = '添加'
        this.type=1 //新增模式
        this.clearForm('editForm');

      }
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // 请求方法
          if(this.loading===true){
            return this.$message({
                  type: 'info',
                  message: '不要重复提交！'
                });
          }
          this.loading = true;
         if(this.editForm.hasOwnProperty('id')){
          var promiss=editAdmin(this.editForm);
         }else{
          var promiss=addAdmin(this.editForm);
         }
         promiss.then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code==200) {
                this.get_admin_list()
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.clearForm('editForm');
              } 
            })
            .catch(err => {
              console.log(err);
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([])
        this.$refs.tree.setCheckedNodes([data])
        this.unitparm.deptId = data.id
        this.unitparm.deptName = data.name
        //交叉点击节点
      } else {
      }
    },
    
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
        this.clearForm('editForm');
      } else if (dialog == 'perm') {
        this.dataAccessshow = false
      } else if (dialog == 'unit') {
        this.unitAccessshow = false
      }
    },
    // 删除客户
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          // alert(row.id)
          adminDelete({id:row.id})
            .then(res => {
              if (res.code==200) {
                this.$message({
                  type: 'success',
                  message: '数据已删除!'
                })
                this.get_admin_list(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },
   
   
   
   

    // 选中菜单
    changemenu(arr) {
      let change = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          change.push(arr[i].id)
        }
      }
      return change
    },
   
    // 下线客户
    offlineUser(index, row) {
      this.$confirm('确定要让' + row.userName + '客户下线吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userExpireToken(row.userName)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '客户' + row.userName + '强制下线成功！'
                })
                this.get_customer_list(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('客户下线失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 刷新缓存
    refreshCache(index, row) {
      userFlashCache(row.userName)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '刷新成功！'
            })
            this.get_admin_list(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('刷新失败，请稍后再试！')
        })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/system/admin.vue